import { LinkedInCallback } from 'react-linkedin-login-oauth2';
import { createBrowserRouter, RouterProvider } from 'react-router';

import * as Sentry from '@sentry/react';

import {
  AuthLayoutRoute,
  ForgotPasswordPage,
  JoinToCoursePage,
  LoginPage,
  NotRequireAuth,
  RegistrationPage,
  RequireAuth,
  ResetPasswordPage
} from 'Auth';
import { ForbiddenPage } from 'Common/ForbiddenPage';
import { NotFoundPage } from 'Common/NotFoundPage';
import { CoursePage, CourseSettingsPage, CoursesPage } from 'Courses';

import { HealthStatusPage } from './HealthStatusPage';
import { urls } from './urls';

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

export const Router = () => {
  const router = sentryCreateBrowserRouter([
    {
      element: <RequireAuth />,
      children: [
        {
          path: urls.homePage,
          element: <CoursesPage />
        },
        {
          path: urls.coursePage(':id'),
          element: <CoursePage />
        },
        {
          path: urls.courseSettingsPage(':id'),
          element: <CourseSettingsPage />
        },
        {
          path: urls.healthStatusPage,
          element: <HealthStatusPage />
        }
      ]
    },
    {
      element: <NotRequireAuth />,
      children: [
        {
          path: '/linkedin',
          element: <LinkedInCallback />
        },
        {
          path: urls.forbiddenPage,
          element: <ForbiddenPage />
        },
        {
          path: urls.notFoundPage,
          element: <NotFoundPage />
        },
        {
          path: '*',
          element: <NotFoundPage />
        }
      ]
    },
    {
      element: <AuthLayoutRoute />,
      children: [
        {
          path: urls.loginPage,
          element: <LoginPage />
        },
        {
          path: urls.registrationPage,
          element: <RegistrationPage />
        },
        {
          path: urls.confirmEmailAndActivateAccountPage(':code'),
          element: <LoginPage />
        },
        {
          path: urls.forgotPasswordPage,
          element: <ForgotPasswordPage />
        },
        {
          path: urls.resetPasswordPage(':hash'),
          element: <ResetPasswordPage />
        },
        {
          path: urls.joinToCoursePage(':joinCode'),
          element: <JoinToCoursePage shouldSkipConfirmation={false} />
        }
      ]
    }
  ]);

  return <RouterProvider router={router} />;
};
